import { createApp } from 'vue';
import { reachGoal } from './metrika.js';

const CheckoutApp = {
    data() {
        return {
            cart: { items: [], dates: [], promoCode: null },
            calculatedCart: null,
            loading: false,
            error: null,
            form: {
                name: '',
                phone: '',
                delivery: null,
                address: '',
                key: this.generateKey()
            },
            deliverySelected: false
        };
    },
    
    computed: {
        isEmpty() {
            return !this.cart.items || this.cart.items.length === 0;
        },
        
        hasSelectedDates() {
            return this.cart.dates && this.cart.dates.length === 2;
        },
        
        totalItems() {
            return this.cart.items.reduce((sum, item) => sum + item.count, 0);
        },
        
        dateDescription() {
            if (!this.hasSelectedDates) return '';
            const [start, end] = this.cart.dates;
            return `${this.formatDate(start)} - ${this.formatDate(end)}`;
        },
        
        isFormValid() {
            return this.form.name.trim() !== '' && this.form.phone.trim() !== '';
        },
        
        isDeliveryValid() {
            if (!this.deliverySelected) return null;
            if (this.form.delivery === false) return true;
            const result = this.form.delivery === true && this.form.address.trim() !== '';
            console.log('isDeliveryValid:', { delivery: this.form.delivery, address: this.form.address, result });
            return result;
        }
    },
    
    methods: {
        generateKey() {
            return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, () => {
                return (Math.random() * 16 | 0).toString(16);
            });
        },
        
        loadCart() {
            const cartData = localStorage.getItem('cart');
            if (cartData) {
                try {
                    this.cart = JSON.parse(cartData);
                    if (this.hasSelectedDates && !this.isEmpty) {
                        this.calculateCart();
                    }
                } catch (e) {
                    console.error("Error parsing cart data from localStorage:", e);
                    this.cart = { items: [], dates: [], promoCode: null };
                }
            }
            
            // Redirect to cart if empty
            if (this.isEmpty) {
                window.location.href = '/cart';
            }
        },
        
        async calculateCart() {
            if (!this.hasSelectedDates || this.isEmpty) {
                return;
            }
            
            this.loading = true;
            this.error = null;
            
            try {
                const response = await fetch('/cart/calculate', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: this.cart.items,
                        dates: this.cart.dates,
                        promoCode: this.cart.promoCode
                    })
                });
                
                const result = await response.json();
                
                if (result.success) {
                    this.calculatedCart = result.data;
                } else {
                    this.error = result.error || 'Ошибка расчета корзины';
                }
            } catch (err) {
                this.error = 'Ошибка сети. Попробуйте позже.';
                console.error('Calculate cart error:', err);
            } finally {
                this.loading = false;
            }
        },
        
        async createOrder() {
            if (!this.isFormValid) {
                alert('Заполните ваше имя и телефон');
                return;
            }
            
            if (this.isEmpty) {
                alert('Корзина пуста');
                return;
            }
            
            this.loading = true;
            this.error = null;
            
            try {
                const response = await fetch('/createorderv2', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: this.form.name,
                        phone: this.form.phone,
                        delivery: this.form.delivery,
                        address: this.form.address,
                        key: this.form.key,
                        items: this.cart.items,
                        dates: this.cart.dates,
                        promoCode: this.cart.promoCode
                    })
                });
                
                if (response.ok) {
                    const result = await response.json();
                    
                    // Clear cart
                    localStorage.removeItem('cart');

                    // The lead goal is sent here, not on /thankyou: that page is reopened by
                    // reload or history and would count one lead several times. The redirect
                    // waits for the goal so that leaving the page does not drop the hit.
                    await reachGoal('lead');
                    
                    // Redirect to thank you page
                    window.location.href = `/thankyou?orderId=${result.id}`;
                } else {
                    const errorData = await response.json();
                    this.error = errorData.message || 'Ошибка создания заказа';
                    alert(this.error);
                }
            } catch (err) {
                this.error = 'Ошибка сети. Попробуйте позже.';
                alert(this.error);
                console.error('Create order error:', err);
            } finally {
                this.loading = false;
            }
        },
        
        formatPrice(price) {
            return new Intl.NumberFormat('ru-RU').format(price);
        },
        
        formatDate(dateStr) {
            const date = new Date(dateStr);
            const day = date.getDate();
            const month = date.toLocaleDateString('ru-RU', { month: 'long' });
            return `${day} ${month}`;
        }
    },
    
    mounted() {
        this.loadCart();
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const appElement = document.getElementById('checkout-app');
    
    if (appElement) {
        if (appElement.__vue_app__) {
            return;
        }
        
        const app = createApp(CheckoutApp);
        app.config.devtools = true;
        
        app.config.errorHandler = (err, instance, info) => {
            console.error('Vue Error:', err, info);
        };
        
        app.mount('#checkout-app');
        window.checkoutApp = app;
    }
});
